/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";
import {useNavigate} from "react-router-dom";

const Tarjeta_Proyectos_Home = ({item}) => {
    const {sCell, masSM, sTab} = useResponsive()
    const navigate = useNavigate()

    return (
        <Grid2
            onClick={() => navigate('/Proyecto/' + item.id)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={12}
            sx={{
                boxShadow: 0,
                borderRadius: 8,
                cursor: 'pointer',
                transition: "all .2s ease-in-out",
                '&:hover': {
                    boxShadow: 4,
                }

            }}
        >

            <Grid2 container size={{xs: 12, sm: 6, md: 4}}>
                <img
                    src={item.img} width={'100%'} height={'auto'}
                    style={{borderRadius: 30}}
                />
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 6, md: 8}}
                   sx={{pl: sCell ? 0 : 6, mt: sCell ? 4 : 0}}>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 32, fontWeight: 800, lineHeight: 1.1}}>
                        {item.titulo}
                    </Typography>
                </Grid2>

                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{
                        fontSize: 20,
                        fontWeight: 400,
                        pt: 2,
                        lineHeight: 1.2,
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 5,
                        textOverflow: "ellipsis",

                    }}>
                        {item.parrafo}
                    </Typography>
                </Grid2>

            </Grid2>

        </Grid2>
    )

}
export default Tarjeta_Proyectos_Home